export const MOBILISER_STAGE_SETTINGS = "settings"
export const MOBILISER_STAGE_PROCESSING_TYPES = "processing-types"
export const MOBILISER_STAGE_REVIEW_TYPES = "review-types"
export const MOBILISER_STAGE_MAPPING = "mapping"

export function getMobiliserStage(options = {}, { upgradesEnabled = true } = {}) {
    const legacyStage = options?.hasConfiguredSettings ? MOBILISER_STAGE_MAPPING : MOBILISER_STAGE_SETTINGS
    if (!upgradesEnabled) return legacyStage
    return options?.mobiliserStage ?? legacyStage
}
